import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import Orb from "./Orb";

const IntroStoryBook = () => {
  const { t } = useTranslation();

  return (
    <section className="story-book py-5">
      <Container>
        <Orb color="rgb(167, 209, 105" top="-10vh" left="-30vh" />

        <Row className="d-flex align-items-center justify-content-center banner-face">
          <Col sm={12} md={6} lg={5} xl={4}>
            <img src="/assets/gray-bg.png" alt="Story Book" width="320" style={{ borderRadius: "50%" }} />
          </Col>
          <Col sm={12} md={6} lg={7} xl={8}>
            <h1 className="display-5 mb-4 section-title" style={{ fontSize: "64px" }}>
              {t("intro-storybook-title")}
            </h1>
            <p style={{ fontWeight: "400", fontSize: "16px" }}>{t("intro-storybook-desc")}</p>
            <button className="btn btn-eclipse">{t("cta-see-catalog")}</button>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default IntroStoryBook;
